export const autoScroll = (x, y) => {
    window.scrollTo(x, y);
}